module.exports = __webpack_public_path__ + "media/honey-icons/icon-monitor-on-1e1fa57c.svg";